import { datadogLogs } from '@datadog/browser-logs'
import type { LogsInitConfiguration, Site } from '@datadog/browser-logs'

export default function useDatadogBrowserLogsClient(
  options: Partial<LogsInitConfiguration> &
    Pick<LogsInitConfiguration, 'service'>
) {
  onBeforeMount(() => {
    if (!import.meta.client) return
    const config = useRuntimeConfig()

    const site: Site =
      // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
      (config.public.datadogSite as Site) || 'us3.datadoghq.com'
    datadogLogs.init({
      clientToken: 'pubc8593913151c3de3f3d832c73b59ffa8',
      site,
      env: process.env.NODE_ENV,
      version: config.public.datadogVersion || 'unknown',
      forwardErrorsToLogs: true,
      sessionSampleRate: 0.01,
      ...options,
    })

    datadogLogs.logger.setLevel('warn')
  })
}
